<template>
  <div>
    <CRow>
      <CCol md="6">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.systemSettings') }}</strong>
          </CCardHeader>
          <CCardBody>
<!--            <CTabs>-->
<!--              <CTab :title="$t('components.warehouse')">-->
                <CDataTable
                    :items="items_warehouse"
                    :fields="fields"
style="height: 400px;overflow: auto"
                    :items-per-page="20"
                    hover
                    border
                    pagination
                >
                  <template #row="{item}">

                    <td style="text-align: center">

                    <p >{{ item.row_id + 1 }}</p>

                    </td>

                  </template>
                  <template #titleFA="{item}">

                    <td>
                      <p class="text-right">{{ item.titleFA }}</p>

                    </td>

                  </template>
                  <template #value="{item}">

                    <td>
                      <CRow v-if="item.valueType==4">
                        <CCol>
                          <CInput v-if="item.valueType==4" type="number"
                      v-on:keypress="isNumber($event)" v-model="item.value[0]"></CInput>

                        </CCol>
                        <CCol>
                          <CInput v-if="item.valueType==4" type="number"
                      v-on:keypress="isNumber($event)" v-model="item.value[1]"></CInput>

                        </CCol>
                        <CCol>
                          <CInput v-if="item.valueType==4" type="number"
                      v-on:keypress="isNumber($event)" v-model="item.value[2]"></CInput>

                        </CCol>
                      </CRow>
                      <CInput class="p-0 m-0" v-if="item.valueType==1 || item.valueType==0" v-model="item.value"></CInput>
                      <CInput v-if="item.valueType==2" type="number"
                      v-on:keypress="isNumber($event)" v-model="item.value"></CInput>

                    </td>

                  </template>

                  <template #prefixOrLenght="{item}">

                    <td>
                      <CInput class="p-0 m-0" v-model="item.prefixOrLenght"></CInput>
                    </td>

                  </template>
                  <template #preview="{item}">

                    <td>
                      <p>{{item.prefixOrLenght}}{{item.value}}</p>
                    </td>

                  </template>

                  <template #operation="{item,index}">
                    <td>

                        <CIcon @click.native="insert_data(item)" class="text-dark" name="saveNew"/>

                    </td>
                  </template>


                </CDataTable>

<!--              </CTab>-->
<!--              <CTab :title="$t('components.product')">-->
<!--                <CDataTable-->
<!--                    :items="items_product"-->
<!--                    :fields="fields"-->

<!--                    :items-per-page="20"-->
<!--                    hover-->
<!--                    sorter-->
<!--                    pagination-->
<!--                >-->
<!--                  <template #row="{item}">-->

<!--                    <td>-->
<!--                      <p >{{ item.row_id + 1 }}</p>-->

<!--                    </td>-->

<!--                  </template>-->
<!--                  <template #titleFA="{item}">-->

<!--                    <td>-->
<!--                      <p >{{ item.titleFA }}</p>-->

<!--                    </td>-->

<!--                  </template>-->
<!--                  <template #value="{item}">-->

<!--                    <td>-->
<!--                      <CRow v-if="item.valueType==4">-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[0]"></CInput>-->

<!--                        </CCol>-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[1]"></CInput>-->

<!--                        </CCol>-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[2]"></CInput>-->

<!--                        </CCol>-->
<!--                      </CRow>-->
<!--                      <CInput v-if="item.valueType==1" v-model="item.value"></CInput>-->
<!--                      <CInput v-if="item.valueType==2" type="number" v-model="item.value"></CInput>-->

<!--                    </td>-->

<!--                  </template>-->

<!--                  <template #prefixOrLenght="{item}">-->

<!--                    <td>-->
<!--                      <CInput v-model="item.prefixOrLenght"></CInput>-->
<!--                    </td>-->

<!--                  </template>-->


<!--                  <template #operation="{item,index}">-->
<!--                    <td>-->

<!--                      <CButton-->
<!--                          color="primary"-->
<!--                          variant="outline"-->
<!--                          square-->
<!--                          :title="$t('buttons.edit')"-->

<!--                          size="sm"-->
<!--                          @click="insert_data(item)"-->
<!--                      >-->
<!--                        <CIcon name="cil-pencil"/>-->
<!--                      </CButton>-->

<!--                    </td>-->
<!--                  </template>-->


<!--                </CDataTable>-->

<!--              </CTab>-->
<!--              <CTab :title="$t('components.accounting')">-->
<!--                <CDataTable-->
<!--                    :items="items_accounting"-->
<!--                    :fields="fields"-->

<!--                    :items-per-page="20"-->
<!--                    hover-->
<!--                    sorter-->
<!--                    pagination-->
<!--                >-->
<!--                  <template #row="{item}">-->

<!--                    <td>-->
<!--                      <p >{{ item.row_id + 1 }}</p>-->

<!--                    </td>-->

<!--                  </template>-->
<!--                  <template #titleFA="{item}">-->

<!--                    <td>-->
<!--                      <p >{{ item.titleFA }}</p>-->

<!--                    </td>-->

<!--                  </template>-->
<!--                  <template #prefixOrLenght="{item}">-->
<!--                    <td>-->
<!--                      <CInput v-model="item.prefixOrLenght"></CInput>-->
<!--                    </td>-->
<!--                  </template>-->
<!--                  <template #value="{item}">-->

<!--                    <td>-->
<!--                      <CRow v-if="item.valueType==4">-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[0]"></CInput>-->

<!--                        </CCol>-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[1]"></CInput>-->

<!--                        </CCol>-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[2]"></CInput>-->

<!--                        </CCol>-->
<!--                      </CRow>-->
<!--                      <CInput v-if="item.valueType==1" v-model="item.value"></CInput>-->
<!--                      <CInput v-if="item.valueType==2" type="number" v-model="item.value"></CInput>-->
<!--                      <treeselect v-if="item.valueType==3"-->
<!--                          :options="items_accounting_list"-->
<!--                          v-model="item.value"-->
<!--                                  appendToBody-->
<!--                          :async="false"-->
<!--                          :placeholder="$t('dialogs.choose')"-->
<!--                      />-->
<!--                    </td>-->

<!--                  </template>-->


<!--                  <template #operation="{item,index}">-->
<!--                    <td>-->

<!--                      <CButton-->
<!--                          color="primary"-->
<!--                          variant="outline"-->
<!--                          square-->
<!--                          :title="$t('buttons.edit')"-->

<!--                          size="sm"-->
<!--                          @click="insert_data(item)"-->
<!--                      >-->
<!--                        <CIcon name="cil-pencil"/>-->
<!--                      </CButton>-->

<!--                    </td>-->
<!--                  </template>-->


<!--                </CDataTable>-->

<!--              </CTab>-->
<!--              <CTab :title="$t('components.accountingGroups')">-->
<!--                <CDataTable-->
<!--                    :items="items_accounting_groups"-->
<!--                    :fields="fields"-->

<!--                    :items-per-page="20"-->
<!--                    hover-->
<!--                    sorter-->
<!--                    pagination-->
<!--                >-->
<!--                  <template #row="{item}">-->

<!--                    <td>-->
<!--                      <p >{{ item.row_id + 1 }}</p>-->

<!--                    </td>-->

<!--                  </template>-->
<!--                  <template #titleFA="{item}">-->

<!--                    <td>-->
<!--                      <p >{{ item.titleFA }}</p>-->

<!--                    </td>-->

<!--                  </template>-->
<!--                  <template #prefixOrLenght="{item}">-->
<!--                    <td>-->
<!--                      <CInput v-model="item.prefixOrLenght"></CInput>-->
<!--                    </td>-->
<!--                  </template>-->
<!--                  <template #value="{item}">-->

<!--                    <td>-->
<!--                      <CRow v-if="item.valueType==4">-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[0]"></CInput>-->

<!--                        </CCol>-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[1]"></CInput>-->

<!--                        </CCol>-->
<!--                        <CCol>-->
<!--                          <CInput v-if="item.valueType==4" type="number" v-model="item.value[2]"></CInput>-->

<!--                        </CCol>-->
<!--                      </CRow>-->
<!--                      <CInput v-if="item.valueType==1" v-model="item.value"></CInput>-->
<!--                      <CInput v-if="item.valueType==2" type="number" v-model="item.value"></CInput>-->
<!--                      <treeselect v-if="item.valueType==3"-->
<!--                                  :options="items_accounting_list"-->
<!--                                  v-model="item.value"-->
<!--                                  :async="false"-->
<!--                                  appendToBody-->
<!--                                  :placeholder="$t('dialogs.choose')"-->
<!--                      />-->
<!--                    </td>-->

<!--                  </template>-->


<!--                  <template #operation="{item,index}">-->
<!--                    <td>-->

<!--                      <CButton-->
<!--                          color="primary"-->
<!--                          variant="outline"-->
<!--                          square-->
<!--                          :title="$t('buttons.edit')"-->

<!--                          size="sm"-->
<!--                          @click="insert_data(item)"-->
<!--                      >-->
<!--                        <CIcon name="cil-pencil"/>-->
<!--                      </CButton>-->

<!--                    </td>-->
<!--                  </template>-->


<!--                </CDataTable>-->

<!--              </CTab>-->
<!--            </CTabs>-->
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'

import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
import BTabs from "../../tabs/BTabs";
var items = [];


export default {
  name: 'Login',
  components: {
    Treeselect,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      setting_key: '',
      setting_value: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      items_warehouse: [],
      items_product: [],
      items_accounting: [],

      fields: [
        // {key: 'row', label: this.$t('tables.row'), _style: 'width:10%'},

        {key: 'titleFA', label: this.$t('title'), _style: 'width:20%;'},
        {key: 'prefixOrLenght', label: this.$t('Prefix'), _style: 'width:10%'},

        {key: 'value', label: this.$t('begin'), _style: 'width:10%;'},
        {key: 'preview', label: this.$t('preview'), _style: 'width:10%;'},
        // {key: 'valueType', label: 'valueType', _style: 'width:20%;'},
        // {key: 'module', label: 'module', _style: 'width:20%;'},
        {key: 'operation', label: "", _style: 'width:5%;'},


      ],
      items_accounting_groups:[],
      items_accounting_list:[],
      items_accounting_sub_groups:[],
      role_checkbox_items: [],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },

  mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
this.get_lists_groups();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function () {
      this.get_lists();
    }
  },
  computed: {},
  methods: {
    get_value_index(value, index) {
      console.log(JSON.parse(value.toString())[index])
      return JSON.parse(value.toString())[index];
      // return  JSON.parse(value)[index]
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.role_checkbox_items = [];

      this.status_form = this.items[item.row_id].id;
      this.get_role_info();
    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.role_checkbox_items = [];
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;
    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      // formData.append('id', this.selected_province);

      axios.post('GetSystemSettings', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
         var my_data = content_data.data.sort(function(a, b){return a.orderNo - b.orderNo});

          my_data.forEach((val) => {
            if (val.valueType == 4) {
              val.value = JSON.parse(val.value.toString())
            }
            if (val.module == 1) {
              self.items_warehouse.push(val)
            }
            if (val.module == 2) {
              self.items_product.push(val)
            }
            if (val.module == 3) {
              self.items_accounting.push(val)
            }
            if (val.module == 4) {
              self.items_accounting_groups.push(val)
            }

          });
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
        } else {
          self.$root.modal_component.show_api_response_modals(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_data(item) {

      // if (!this.validateForm()) {
      //   console.log("validate form is false" + this.validate_errors);
      //   return true;
      // }
      let self = this;
      // var grp_info = {groupName:self.name};
      // var operation_systems = new Array();
//grp_info.groupName = self.name;

      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "UpdateSystemSetting";
      } else {
        url = "UpdateSystemSetting";

      }
      // var person = new Object();
      // person.groupName = self.name;
      formData.append('id', item.id)

      // console.log("json group"+ JSON.stringify(person));
      formData.append('Value', item.value);
      formData.append('prefixOrLenght', item.prefixOrLenght);
      // formData.append('OperationSystems',  OperationSystems);
      axios.post(url, formData, {}).then((res) => {

        // self.$root.modal_component.show_api_response_modals(res)
        //
        // self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_lists_groups() {
      var self = this;
      self.items_accounting_list = [];

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";

      // formData.append("id", 1);

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              response.data.data.forEach((val) => {
                if (val.parentId == 0) {

                  var obj = {
                    label: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    id: val.id,
                    children: self.get_childrens(val.id, response.data.data)
                  }
                  self.items_accounting_list.push(obj);
                }

              });

            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },
    get_childrens(parent_id, list) {
      var array = [];
      list.forEach((val2) => {

        if (parent_id == val2.parentId) {
          var obj = {
            label: val2.accountName, name_code: val2.accountName + " (" + val2.accountCode + ")",
            code: val2.accountCode, id: val2.id, nature: val2.nature,
            type: val2.type,
          }
          if(this.get_childrens(val2.id, list)==null){
            obj.children= this.get_childrens(val2.id, list)
          }
          array.push(obj);
          // val2.inserted = true;

        }
      });
      if(array.length){
        return array;

      }else{
        return null;

      }
    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteSetting";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
